import logo from './logo.svg';
import './App.css';
import {Routes ,Route, BrowserRouter } from 'react-router-dom';
import UsersList from './components/UsersList'
import UserAdd from './components/UserAdd'
import UserUpdate from './components/UserUpdate'
import UserShow from './components/UserShow'
function App() {
  return (
<BrowserRouter>
<Routes>
  <Route path='/' element={<UsersList/>} />
  <Route path='/add' element={<UserAdd/>} />
  <Route path='/edit/:id' element={<UserUpdate/>} />
  <Route path='/show/:id' element={<UserShow/>} />
</Routes>
</BrowserRouter>
  );
}

export default App;
